import { TableHeadCell } from "@shared/primitive-components"

export const tripCompletedHeaderProps = {
  header: `Trip completed`,
  tooltipContent: `Each individual trip completed by your fleet. A trip is classed as 'complete' every time a vehicle becomes stationary for 10 minutes or more.`,
}

export const TripCompletedHeader = () => <TableHeadCell {...tripCompletedHeaderProps} />
